import { Component, OnInit, HostListener } from '@angular/core';
import { CWSMSAPIService } from '../cwsmsapi.service';
import { MatTabChangeEvent } from '@angular/material';
import { MatDialog, MatDialogRef, MatMenuTrigger, MatIconRegistry } from '@angular/material';
import { FileImportComponent } from '../file-import/file-import.component';
import { RecipientListsComponent } from '../recipient-lists/recipient-lists.component';
import { DomSanitizer } from '@angular/platform-browser';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import { TranslateService } from '@ngx-translate/core';

declare var getSMSLengthInfo: any;

@Component({
  selector: 'app-sendsms',
  templateUrl: './sendsms.component.html',
  styleUrls: ['./sendsms.component.css']
})
export class SendsmsComponent implements OnInit {

	recipientList: any = [];
	singleRecipient: any = "";
	uploadFileValue: any = "";
	preferredCountries: any = ['no', 'se', 'dk'];
	errorMessage: string = "";
	senderName: any = "";
	messageContent: any = "";
	sendSMSLoader: boolean = false;
	sendSMSProgress: number = 0;
	sendSMSProgressGoal: number = 0;
	messageCredits: number = 0;
	sidemenuOpen: boolean = true;
	recipientListLoaded: boolean = false;
	recipientListName: string = "";
	editingList: boolean = false;
	lists: any = [];
	selectedList: any;
	recipientListStyle: any = "";
	loading: boolean = false;
	editingSenderName: boolean = false;
	smsLengthInfo: any;
	addButtonText: any = "Add";
	premiumSMS: boolean = false;

	screenHeight: number;
	screenWidth: number;

	constructor(public iconRegistry: MatIconRegistry, public cwsms: CWSMSAPIService, public dialog: MatDialog, public sanitizer: DomSanitizer, public translate: TranslateService) {
		iconRegistry.addSvgIcon('remove',sanitizer.bypassSecurityTrustResourceUrl('assets/img/remove.svg'));
		this.onResize();
	}

	@HostListener('window:resize', ['$event'])
	onResize(event?) {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;

		if (this.screenWidth < 720) {
			this.sidemenuOpen = false;
		} else {
			this.sidemenuOpen = true;
		}

		if (this.screenWidth < 450) {
			this.addButtonText = "";
		} else {
			this.addButtonText = this.translate.instant("Add");
		}
	}

	toggleSidemenu() {
		if (this.sidemenuOpen) {
			this.sidemenuOpen = false;
		} else {
			this.sidemenuOpen = true;
		}
	}

	ngOnInit() {
		this.loadSessionStorage();
		this.getRecipientLists();
		this.smsLengthInfo = getSMSLengthInfo(this.messageContent);
	}

	loadSessionStorage() {
		var senderName = sessionStorage.getItem("senderName");

		if (senderName !== null) {
			this.senderName = senderName;
		}

		var messageContent = sessionStorage.getItem("messageContent");
		if (messageContent !== null) {
			this.messageContent = messageContent;
		}
		
		/*
		var recipients = sessionStorage.getItem("recipientList");
		if (recipients !== null) {
			try {
				this.recipientList = JSON.parse(recipients);
			} catch (e) {
				console.log("Could not parse recipient list...");
			}
		}
		*/
	}

	closeSMSLoader() {
		this.sendSMSLoader = false;
	}

	receivedSideMenuEvent(event) {
		if ("userData" in event) {
			this.messageCredits = event.userData.credits.N;

			if ("defaultSenderName" in event.userData) {
				this.senderName = event.userData.defaultSenderName.S;
			}
		}
	}

	senderNameChanged(event) {
		sessionStorage.setItem("senderName", this.senderName);
	}

	messageContentChanged(event) {
		setTimeout( () => {
			sessionStorage.setItem("messageContent", this.messageContent);
			this.smsLengthInfo = getSMSLengthInfo(this.messageContent);
		}, 100);
	}

	recipientListChanged() {
		//sessionStorage.setItem("recipientList", JSON.stringify(this.recipientList));
	}

	sendNextSMSBatch(currentOffset, msgClass) {
		var msgPerBatch = 100;
		var currentRecipients = this.recipientList.slice(currentOffset, currentOffset+msgPerBatch);

		if (currentRecipients.length > 0) {
			console.log("Sending next batch...");
			console.log(currentRecipients);
			this.cwsms.post('/send/sms/manual', {
				sender: this.senderName,
				message: this.messageContent,
				recipients: currentRecipients,
				class: msgClass
			}, (err, data) => {
				if (err) {
					console.log(err);
					this.sendSMSLoader = false;
					this.errorMessage =  "Error sending SMS: ";
					if ("error" in err && "message" in err.error) {
						this.errorMessage += err.error.message;
					} else {
						this.errorMessage += "Unknown error!";
					}
				} else {
					setTimeout( () => {
						this.sendSMSProgress += currentRecipients.length;
						this.sendNextSMSBatch(currentOffset+msgPerBatch, msgClass);
					}, 500);
				}
			});
		} else {
			this.cwsms.changeMessage("sidemenu:updateUser");
			console.log("Done!");
		}
	}

	sendSMS() {
		if (this.senderName.length < 3) {
			this.errorMessage = this.translate.instant("Invalid sender name!");
			return;
		} else if (this.messageContent.length <= 0) {
			this.errorMessage = this.translate.instant("Invalid message content!");
			return;
		} else if (this.recipientList.length <= 0) {
			this.errorMessage = this.translate.instant("There's no recipients!");
			return;
		}

		this.errorMessage = "";

		this.sendSMSProgress = 0;
		this.sendSMSProgressGoal = this.recipientList.length;
		this.sendSMSLoader = true;

		var msgClass = "standard";
		if (this.premiumSMS) {
			msgClass = "premium";
		}

		this.cwsms.post('/prices/list', {
			recipients: this.recipientList,
			message: this.messageContent,
			class: msgClass
		}, (err, data) => {
			if (err) {
				this.sendSMSLoader = false;
			} else {
				console.log("Message credits: "+this.messageCredits);
				console.log("Total cost: "+data.cost);
				if (this.messageCredits < data.cost) {
					this.sendSMSLoader = false;
					this.errorMessage = this.translate.instant("Error sending SMS: Insufficient credits!");
				} else {
					this.sendNextSMSBatch(0, msgClass);
				}
			}
		});
	}

	getPhoneNumberFlagCountryCode(phoneNumber) {
		var ret = this.cwsms.getPhoneNumberCountryCode(phoneNumber);
		if (ret !== null) {
			return ret.toLowerCase();
		}
		return "";
	}

	scrollToBottom() {
		setTimeout(() => {
			var objDiv = document.getElementById("recipients-list");
			objDiv.scrollTop = objDiv.scrollHeight;
		}, 200);
	}

	addSingleRecipient() {
		var intPhoneNumber = "+"+this.singleRecipient;
		if (this.cwsms.getPhoneNumberCountryCode(intPhoneNumber) !== null) {
			this.errorMessage = "";
			this.recipientList.push(intPhoneNumber);
			this.singleRecipient = "";
			var pn: any = document.getElementById("phone");
			pn.value = "";
			this.recipientListChanged();
			this.scrollToBottom();
		} else {
			this.errorMessage = "Invalid recipient phone number!";
		}
	}

	newRecipientList() {
		this.recipientListName = "New recipient list";
		this.recipientListLoaded = true;
		this.selectedList = "";
		this.recipientList = [];
		this.editList();
	}


	/*
	loadRecipientList(lid) {
		let dialogRef:MatDialogRef<RecipientListsComponent> = this.dialog.open(RecipientListsComponent, {});
		dialogRef.afterClosed().subscribe(result => {
			if (result !== undefined && result !== null && result.length > 0) {
				this.recipientList = result;
				this.recipientListChanged();
				this.scrollToBottom();
			}
		});		
	}
	*/

	openRecipientList(lid) {
		this.selectedList = lid;
		this.loading = true;
		console.log("Opening list ID: "+this.selectedList);
		this.cwsms.get('/user/recipient-list/'+this.selectedList, (err, data) => {
			this.loading = false;
			if (err) {
				console.log(err);
			} else {
				console.log(data);
				this.recipientListLoaded = true;
				this.recipientListName = data.label.S;

				this.recipientList = [];
				for (var recipient of data.recipients.L) {
					this.recipientList.push(recipient.S);
				}
			}
		});
	}

	getRecipientLists() {
		this.loading = true;
		this.cwsms.get('/user/recipient-lists', (err, data) => {
			this.loading = false;
			if (err) {
				console.log(err);
			} else {
				this.lists = data.lists;
				console.log(data);
			}
		});
	}

	saveRecipientList() {
		this.loading = true;
		if (this.recipientListName.length <= 0) {
			this.recipientListName = "No name";
		}

		var formattedRecipientList = [];
		for (var r of this.recipientList) {
			formattedRecipientList.push({S:r});
		}

		var path = '/user/recipient-list';
		if (this.selectedList.length > 0) {
			path += '/'+this.selectedList;
		}
		this.cwsms.post(path, {
			label: this.recipientListName,
			recipients: formattedRecipientList
		}, (err, data) => {
			this.loading = false;
			if (err) {
				console.log(err);
			} else {
				console.log(data);
				this.stopEditingList();
			}
		});
	}

	deleteRecipientList() {
		if (this.selectedList.length <= 0) {
			this.stopEditingList();
			this.recipientListLoaded = false;
		} else {
			if (confirm(this.translate.instant("Are you sure you wish to delete this recipient list?"))) {
				this.cwsms.delete('/user/recipient-list/'+this.selectedList, (err, data) => {
					if (err) {
						console.log(err);
					} else {
						console.log(data);
						this.selectedList = "";
						this.recipientListLoaded = false;
						this.stopEditingList();
						this.getRecipientLists();
					}
				});
			}
		}
	}

	stopEditingList() {
		this.recipientListStyle = "";
		this.editingList = false;
	}

	editList() {
		this.errorMessage = "";
		this.recipientListStyle = this.sanitizer.bypassSecurityTrustStyle("border-radius: 10px; border: 3px dashed white; padding: 15px;");
		this.editingList = true;
	}

	goBack() {
		this.errorMessage = "";
		this.recipientListLoaded = false;
		this.getRecipientLists();
	}

	handleFile(e) {
		let dialogRef:MatDialogRef<FileImportComponent> = this.dialog.open(FileImportComponent, {
			data: {e:e}
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result !== undefined && result !== null && result.length > 0) {
				this.recipientList = this.recipientList.concat(result);
				this.recipientListChanged();
				this.scrollToBottom();
			}
			this.uploadFileValue = "";
		});
	}

	removeRecipient(index) {
		this.recipientList.splice(index, 1);
		this.recipientListChanged();
	}

	editSenderName() {
		this.editingSenderName = true;
	}

	saveSenderName() {
		this.loading = true;
		this.cwsms.post('/user/default-sender-name', {
			defaultSenderName: this.senderName
		}, (err, data) => {
			this.loading = false;
			if (err) {
				console.log(err);
				this.errorMessage = "Error: Sender name not saved!";
			} else {
				console.log(data);
				this.editingSenderName = false;
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/sendsms/sendsms.component.ts